(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const textRect = (element) => {
      const range = document.createRange();
      range.selectNodeContents(element);
      return range.getBoundingClientRect();
    };

    const alignDropdown = (item) => {
      if (!window.matchMedia('(min-width: 750px)').matches ||
          !item.closest('#header-component[data-menu-style="menu"]') ||
          item.getAttribute('slot') === 'overflow') return;

      const submenu = item.querySelector(':scope > .menu-list__submenu');
      const title = item.querySelector(':scope > .menu-list__trigger .menu-list__link-title');
      const list = submenu?.querySelector('.mega-menu__list');
      const firstLink = list?.querySelector('.mega-menu__link');
      if (!submenu || submenu.inert || !title || !list || !firstLink) return;

      submenu.style.setProperty('--dropdown-align-offset', '0px');
      const rtl = getComputedStyle(title).direction === 'rtl';
      const titleBounds = textRect(title);
      const linkBounds = textRect(firstLink.querySelector('.wrap-text') || firstLink);
      const offset = rtl
        ? linkBounds.right - titleBounds.right
        : titleBounds.left - linkBounds.left;

      // Keep links clear of the panel edge and any featured content.
      const inner = submenu.querySelector('.menu-list__submenu-inner');
      if (!inner) return;
      const innerBounds = inner.getBoundingClientRect();
      const bounds = Array.from(list.querySelectorAll('.mega-menu__link')).map((link) =>
        textRect(link.querySelector('.wrap-text') || link)
      );
      list.querySelectorAll('img').forEach((image) => bounds.push(image.getBoundingClientRect()));
      const featured = submenu.querySelector('.mega-menu__content');
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      const edge = featured
        ? (rtl ? featured.getBoundingClientRect().right + gap : featured.getBoundingClientRect().left - gap)
        : (rtl ? innerBounds.left + 16 : innerBounds.right - 16);
      const contentEdge = rtl
        ? Math.min(...bounds.map((bound) => bound.left))
        : Math.max(...bounds.map((bound) => bound.right));
      const available = rtl ? contentEdge - edge : edge - contentEdge;
      const shift = Math.max(0, Math.min(offset, available));
      submenu.style.setProperty('--dropdown-align-offset', `${shift}px`);
    };

    const alignFromEvent = (event) => {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest('.header-menu .menu-list__list-item');
      if (item) requestAnimationFrame(() => alignDropdown(item));
    };

    document.addEventListener('pointerover', alignFromEvent, true);
    document.addEventListener('focusin', alignFromEvent, true);
    window.addEventListener('resize', () => {
      requestAnimationFrame(() => {
        document.querySelectorAll('.header-menu .menu-list__list-item').forEach(alignDropdown);
      });
    });
    document.fonts?.ready.then(() => {
      document.querySelectorAll('.header-menu .menu-list__list-item').forEach(alignDropdown);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
